import axios from "axios";

// Em produção/domínio custom, chama a API pela mesma origem (/api) — cookies 1st-party
// (cross-site para emergent.host é bloqueado por Safari/navegadores com ITP).
// Em dev local (localhost:3000), usa a URL absoluta do backend.
const isLocalDev = ["localhost", "127.0.0.1"].includes(window.location.hostname);
export const API_ORIGIN = isLocalDev ? process.env.REACT_APP_BACKEND_URL : "";

const api = axios.create({
  baseURL: `${API_ORIGIN}/api`,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Algo deu errado. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
